import { useWorkshopOrganizers } from "@/lib/api";
import { MenuItem, Skeleton } from "@mui/material";
import PropTypes from "prop-types";
import SelectStyled from "../SelectStyled";

export const WorkshopOrganizerSelector = ({ name, label, onChange, ...props }) => {
    const { organizers, isLoading, isError } = useWorkshopOrganizers();

    const handleSelected = (event) => {
        if (onChange) {
            onChange(event);
        }
    }

    if (isLoading) {
        return <Skeleton />
    }

    return (
        <>
            <SelectStyled
                fullWidth
                name={name}
                label={label}
                placeholder="Alle Workshops"
                variant="filled"
                inputProps={{ "aria-label": "Veranstaltet von" }}
                onChange={handleSelected}
                renderValue={e => e?.name ?? "Alle Workshops"}
            >
                <MenuItem value="">Alle Workshops</MenuItem>
                {organizers.map((organizer) => {
                    return <MenuItem key={organizer.id} value={organizer}>{organizer.name}</MenuItem>
                })}
            </SelectStyled>
        </>
    );
};

WorkshopOrganizerSelector.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func
};
